// Code generated by Slice Machine. DO NOT EDIT.

import BackgroundReplacer from './BackgroundReplacer';
import Banner from './Banner';
import BenefitList from './BenefitList';
import Brands from './Brands';
import Button from './Button';
import CustomCss from './CustomCss';
import CustomHtml from './CustomHtml';
import DesignFeedSection from './DesignFeedSection';
import Divider from './Divider';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions';
import GeneralCard from './GeneralCard';
import HeroImage from './HeroImage';
import Image from './Image';
import ImageGrid from './ImageGrid';
import ImageRow from './ImageRow';
import ImageSection from './ImageSection';
import InfoBox from './InfoBox';
import KittlPlusBanner from './KittlPlusBanner';
import LandingVideo from './LandingVideo';
import LinkListSection from './LinkListSection';
import NonFeedFooterColumn from './NonFeedFooterColumn';
import NumberShowcase from './NumberShowcase';
import OpenGraphCard from './OpenGraphCard';
import Plans from './Plans';
import Quote from './Quote';
import ReferralNudgeBanner from './ReferralNudgeBanner';
import Slideshow from './Slideshow';
import Spacer from './Spacer';
import TabShowcase from './TabShowcase';
import TeamCreationBanner from './TeamCreationBanner';
import Testimonials from './Testimonials';
import Text from './Text';
import TextSection from './TextSection';
import Title from './Title';
import Vectorizer from './Vectorizer';
import Video from './Video';
import YourSubscription from './YourSubscription';

export {
  BackgroundReplacer,
  Banner,
  BenefitList,
  Brands,
  Button,
  CustomCss,
  CustomHtml,
  DesignFeedSection,
  Divider,
  FrequentlyAskedQuestions,
  GeneralCard,
  HeroImage,
  Image,
  ImageRow,
  ImageSection,
  ImageGrid,
  InfoBox,
  KittlPlusBanner,
  LandingVideo,
  LinkListSection,
  NonFeedFooterColumn,
  NumberShowcase,
  OpenGraphCard,
  Plans,
  Quote,
  ReferralNudgeBanner,
  Slideshow,
  Spacer,
  TabShowcase,
  TeamCreationBanner,
  Testimonials,
  Text,
  TextSection,
  Title,
  Vectorizer,
  Video,
  YourSubscription,
};

export const components = {
  background_replacer: BackgroundReplacer,
  banner: Banner,
  benefit_list: BenefitList,
  brands: Brands,
  button: Button,
  custom_css: CustomCss,
  custom_html: CustomHtml,
  design_feed_section: DesignFeedSection,
  divider: Divider,
  frequently_asked_questions: FrequentlyAskedQuestions,
  general_card: GeneralCard,
  hero_image: HeroImage,
  image: Image,
  image_row: ImageRow,
  image_section: ImageSection,
  image_grid: ImageGrid,
  info_box: InfoBox,
  kittl_plus_banner: KittlPlusBanner,
  landing_video: LandingVideo,
  link_list_section: LinkListSection,
  non_feed_footer_column: NonFeedFooterColumn,
  number_showcase: NumberShowcase,
  open_graph_card: OpenGraphCard,
  plans: Plans,
  quote: Quote,
  referral_nudge_banner: ReferralNudgeBanner,
  slideshow: Slideshow,
  spacer: Spacer,
  tab_showcase: TabShowcase,
  team_creation_banner: TeamCreationBanner,
  testimonials: Testimonials,
  text: Text,
  text_section: TextSection,
  title: Title,
  vectorizer: Vectorizer,
  video: Video,
  your_subscription: YourSubscription,
};
